/**
 * Footer Navigation Configuration
 *
 * Data-driven footer columns and legal links. The footer is the site's
 * complete sitemap (knowledgebase/briefs/BRIEF-footer.md): what the header
 * menus leave out must be findable here. PageFooter renders FOOTER_COLUMNS as
 * the mobile accordion and the desktop columns alike, in this order.
 * All paths reference the centralized routes object.
 */

import { routes } from "@/lib/routes";

export interface FooterColumn {
  heading: string;
  ariaLabel: string;
  links: { href: string; label: string }[];
}

export const FOOTER_COLUMNS: FooterColumn[] = [
  {
    heading: "Maßnahmen",
    ariaLabel: "Maßnahmen",
    links: [
      { href: routes.content.kompensationsmassnahmen, label: "Alle Maßnahmen" },
      { href: routes.content.oekopunkte, label: "Ökopunkte" },
      { href: routes.content.ausgleichsflaechen, label: "Ausgleichsflächen" },
      { href: routes.content.biotopausgleich, label: "Biotopausgleich" },
      { href: routes.content.forstausgleichWaldumwandlung, label: "Forstausgleich" },
      { href: routes.content.artenschutz, label: "Artenschutz" },
      { href: routes.content.cefMassnahmen, label: "CEF-Maßnahmen" },
      { href: routes.content.leistungen, label: "Leistungen" },
    ],
  },
  {
    heading: "Für Vorhabenträger",
    ariaLabel: "Für Vorhabenträger",
    links: [
      { href: routes.content.vorhabentraeger, label: "Alles für Vorhabenträger" },
      { href: routes.content.oekopunkteKaufen, label: "Ökopunkte kaufen" },
      { href: routes.content.kompensationAnfragen, label: "Kompensation anfragen" },
      { href: routes.content.kompensationsberatung, label: "Kompensationsberatung" },
      { href: routes.content.erneuerbareEnergien, label: "Erneuerbare Energien" },
      { href: routes.content.infrastrukturentwickler, label: "Für Infrastruktur" },
      { href: routes.content.kommune, label: "Für Kommunen" },
      { href: routes.content.preisindex, label: "Preisindex" },
    ],
  },
  {
    heading: "Für Flächeneigentümer",
    ariaLabel: "Für Flächeneigentümer",
    links: [
      { href: routes.content.flaecheneigentuemer, label: "Alles für Flächeneigentümer" },
      { href: routes.content.oekopunkteVerkaufen, label: "Ökopunkte verkaufen" },
      { href: routes.content.flaecheAnbieten, label: "Fläche anbieten" },
      { href: routes.content.flaecheBewertenLassen, label: "Fläche kostenfrei bewerten" },
      { href: routes.content.potenzialanalyseFlaeche, label: "Potenzialanalyse" },
      { href: routes.content.forstwirt, label: "Für Forstwirte" },
      { href: routes.content.stiftung, label: "Für Stiftungen" },
    ],
  },
  {
    heading: "Wissen",
    ariaLabel: "Wissen",
    links: [
      { href: routes.content.wasSindOekopunkte, label: "Was sind Ökopunkte" },
      { href: routes.content.compensationTypes, label: "Alle Kompensationsarten" },
      { href: routes.content.glossar, label: "Glossar" },
      { href: routes.content.bundeslandUebersicht, label: "Bundesland-Übersicht" },
      { href: routes.content.naturraumPlz, label: "Naturraum per PLZ" },
      { href: routes.content.eingriffsregelungVergleich, label: "Eingriffsregelung im Vergleich" },
    ],
  },
  {
    heading: "Unternehmen",
    ariaLabel: "Unternehmen",
    links: [
      { href: routes.content.ueberUns, label: "Über uns" },
      { href: routes.content.referenzen, label: "Referenzen" },
      { href: routes.content.kontakt, label: "Kontakt" },
    ],
  },
];

export const FOOTER_LEGAL_LINKS = [
  { href: routes.content.impressum, label: "Impressum" },
  { href: routes.content.datenschutz, label: "Datenschutz" },
  { href: routes.content.agb, label: "AGB" },
];
